import React, { useState } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
function TooltipButton() {
  return (
    <>
      <span id="my-resume">
        <AiOutlineCloudDownload size={30}></AiOutlineCloudDownload>
      </span>

      <ReactTooltip
        anchorId="my-resume"
        place="bottom"
        content="Dowload Resume"
      />
    </>
  );
}

export default TooltipButton;
